/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const AUTH0_CLIENT_ID = String(process.env.REACT_APP_AUTH0_CLIENT_ID);
export const AUTH0_DOMAIN = String(process.env.REACT_APP_AUTH0_DOMAIN);
export const AUTH0_CACHE_LOCATION = String(
  process.env.REACT_APP_CACHE_LOCATION || "memory"
);
export const BASE_NAME = String(process.env.REACT_APP_BASE_NAME || "");
export const ENVIRONMENT = String(process.env.REACT_APP_ENV);
